import React from 'react';
import chroma from 'chroma-js';

import Graphic from '../Graphic';
import { useTheme } from '../../../hooks/index';

const LiveChat = props => {
  const { primary } = useTheme();

  return (
    <Graphic
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 140 145"
      preserveAspectRatio="xMidYMid meet"
      fill="none"
      {...props}>
      <path
        fill="#F3F3F4"
        d="M70.5 144.75c28.166 0 51-1.567 51-3.5s-22.834-3.5-51-3.5-51 1.567-51 3.5 22.834 3.5 51 3.5Z"
      />
      <path
        fill="#D9D9D9"
        d="M70.155 139.214c33.775 0 61.155-27.359 61.155-61.107S103.93 17 70.155 17C36.38 17 9 44.358 9 78.107c0 33.748 27.38 61.107 61.155 61.107Z"
      />
      <path
        fill="#D9D9D9"
        d="M109.491 124.75c-10.74 9.343-24.776 15-40.135 15-15.226 0-29.152-5.56-39.856-14.758v-.242h79.991Z"
      />
      <path
        fill={primary}
        fillOpacity=".75"
        d="M109.491 124.75c-10.74 9.343-24.776 15-40.135 15-15.226 0-29.152-5.56-39.856-14.758v-.242h79.991Z"
      />
      <path
        fill="#D9D9D9"
        d="M46.166 118.107c0 2.959-2.462 5.357-5.5 5.357-3.037 0-5.5-2.398-5.5-5.357s2.463-5.357 5.5-5.357c3.038 0 5.5 2.398 5.5 5.357Z"
      />
      <path
        fill={primary}
        fillOpacity=".5"
        d="M46.166 118.107c0 2.959-2.462 5.357-5.5 5.357-3.037 0-5.5-2.398-5.5-5.357s2.463-5.357 5.5-5.357c3.038 0 5.5 2.398 5.5 5.357Z"
      />
      <path
        fill="#D9D9D9"
        d="M60.833 118.107c0 2.959-2.462 5.357-5.5 5.357s-5.5-2.398-5.5-5.357 2.462-5.357 5.5-5.357 5.5 2.398 5.5 5.357Z"
      />
      <path
        fill={primary}
        fillOpacity=".5"
        d="M60.833 118.107c0 2.959-2.462 5.357-5.5 5.357s-5.5-2.398-5.5-5.357 2.462-5.357 5.5-5.357 5.5 2.398 5.5 5.357Z"
      />
      <path
        fill="#D9D9D9"
        d="M49.833 136.57v-.606c0-4.931-4.104-8.928-9.167-8.928-2.22 0-4.255.769-5.841 2.047l15.008 7.487Z"
      />
      <path
        fill={primary}
        fillOpacity=".5"
        d="M49.833 136.57v-.606c0-4.931-4.104-8.928-9.167-8.928-2.22 0-4.255.769-5.841 2.047l15.008 7.487Z"
      />
      <path
        fill="#D9D9D9"
        d="M53.779 137.75H64.5v-1.786c0-4.931-4.104-8.928-9.167-8.928a9.323 9.323 0 0 0-4.583 1.194 12.245 12.245 0 0 1 2.635 9.415l.394.105Z"
      />
      <path
        fill={primary}
        fillOpacity=".5"
        d="M53.779 137.75H64.5v-1.786c0-4.931-4.104-8.928-9.167-8.928a9.323 9.323 0 0 0-4.583 1.194 12.245 12.245 0 0 1 2.635 9.415l.394.105Z"
      />
      <path
        fill={primary}
        fillOpacity=".75"
        fillRule="evenodd"
        d="M110.816 124.85c.279-.248.556-.497.83-.748a.502.502 0 0 0 .031-.707.5.5 0 0 0-.707-.03c-.54.495-1.089.981-1.646 1.457a.51.51 0 0 0-.186.343.51.51 0 0 0 .118.373.495.495 0 0 0 .717.044c.283-.241.564-.485.843-.732Zm3.274-4.556a.497.497 0 0 0-.105.555.495.495 0 0 0 .672.251.492.492 0 0 0 .159-.119 61.737 61.737 0 0 0 4.316-5.089.499.499 0 0 0-.466-.798.503.503 0 0 0-.331.193 60.455 60.455 0 0 1-4.245 5.007Zm-9.417 9.343a.494.494 0 0 0 .21-.321.512.512 0 0 0-.079-.374.504.504 0 0 0-.515-.208.522.522 0 0 0-.18.077 60.106 60.106 0 0 1-3.7 2.336.503.503 0 0 0-.181.684.502.502 0 0 0 .684.181 62.11 62.11 0 0 0 3.761-2.375Zm-5.706 3.46a.502.502 0 0 0-.09-.92.5.5 0 0 0-.381.038c-18.15 9.695-39.99 9.416-57.775-.37a.49.49 0 0 0-.38-.043.514.514 0 0 0-.3.239.505.505 0 0 0 .048.554.51.51 0 0 0 .15.126c18.08 9.947 40.277 10.232 58.729.376Zm24.138-25.146a.509.509 0 0 0 .048.554.488.488 0 0 0 .529.168.507.507 0 0 0 .299-.239c9.968-18.084 10.274-40.283.434-58.727a.498.498 0 0 0-.676-.207.498.498 0 0 0-.207.677c9.68 18.144 9.379 39.983-.427 57.774Zm-.639-59.687a.503.503 0 0 0 .684.18.5.5 0 0 0 .181-.683 60.79 60.79 0 0 0-2.374-3.762.498.498 0 0 0-.904.19.501.501 0 0 0 .078.374 60.066 60.066 0 0 1 2.335 3.7Zm-89.689 79.612a.52.52 0 0 0 .37.097.504.504 0 0 0 .428-.564.496.496 0 0 0-.194-.33 60.521 60.521 0 0 1-5.007-4.244.504.504 0 0 0-.35-.117.504.504 0 0 0-.473.5.5.5 0 0 0 .136.344 61.529 61.529 0 0 0 5.09 4.314Zm-8.212-7.484a.497.497 0 0 0 .868-.317.5.5 0 0 0-.13-.359 69.981 69.981 0 0 1-.7-.776C2.46 93.87 4.83 55.582 29.905 33.397c25.076-22.185 63.367-19.87 85.551 5.16.231.263.46.526.686.79a.503.503 0 0 0 .716.069.503.503 0 0 0 .147-.547.485.485 0 0 0-.103-.171 54.86 54.86 0 0 0-.655-.755l-.006-.008-.036-.04-.035-.04a61.688 61.688 0 0 0-3.805-3.926.435.435 0 0 0-.065-.073 61.243 61.243 0 0 0-5.09-4.314.48.48 0 0 0-.128-.071 61.168 61.168 0 0 0-7.186-4.653.5.5 0 0 0-.147-.12c-18.08-9.95-40.278-10.234-58.728-.377a.5.5 0 0 0-.22.237 57.12 57.12 0 0 0-1.407.785.498.498 0 0 0-.318.063 61.565 61.565 0 0 0-3.761 2.375.5.5 0 0 0-.196.262 62.244 62.244 0 0 0-4.8 3.673.5.5 0 0 0-.305.12c-.566.483-1.123.977-1.672 1.48a.5.5 0 0 0-.156.288 62.467 62.467 0 0 0-2.724 2.682.499.499 0 0 0-.29.15 61.682 61.682 0 0 0-4.316 5.09.499.499 0 0 0-.102.308 61.237 61.237 0 0 0-4.513 6.935.499.499 0 0 0-.234.215C6.04 67.068 5.733 89.266 15.574 107.71c.025.048.058.09.095.125.302.565.613 1.127.934 1.684.012.047.03.093.055.136a61.961 61.961 0 0 0 2.373 3.763.496.496 0 0 0 .076.087 62.091 62.091 0 0 0 4.71 6.056l.036.04.043.048c.221.25.443.497.67.742Z"
        clipRule="evenodd"
      />
      <path fill="#fff" stroke={primary} d="M1 16h88v85H1V16Z" />
      <path
        fill="#D9D9D9"
        d="M19.5 20.75h-13a1 1 0 0 0-1 1v74a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1v-74a1 1 0 0 0-1-1ZM53.423 23.976h-16.97a1 1 0 0 0-1 1v13.058a1 1 0 0 0 1 1h16.97a1 1 0 0 0 1-1V24.976a1 1 0 0 0-1-1ZM45.435 48.069h-16.97a1 1 0 0 0-1 1v13.058a1 1 0 0 0 1 1h16.97a1 1 0 0 0 1-1V49.069a1 1 0 0 0-1-1ZM63.407 72.161h-16.97a1 1 0 0 0-1 1v13.058a1 1 0 0 0 1 1h16.97a1 1 0 0 0 1-1V73.161a1 1 0 0 0-1-1ZM84.374 23.976H70.399a1 1 0 0 0-1 1v30.123a1 1 0 0 0 1 1h13.975a1 1 0 0 0 1-1V24.976a1 1 0 0 0-1-1ZM28.458 20.964h-1.986a1.004 1.004 0 1 0 0 2.008h1.986a1.004 1.004 0 1 0 0-2.008Z"
      />
      <path
        fill={primary}
        fillRule="evenodd"
        d="M46.52 36.488c.325.138.62.338.866.59a2.666 2.666 0 0 1-3.378 4.084l1.845-1.845-.283-.283h-.848l-1.432 1.432a2.673 2.673 0 0 1-.276-2.537 2.668 2.668 0 0 1 3.507-1.441Zm-8.518 9.266 5.288-5.288c.096.137.204.265.324.383.118.114.245.215.38.304l.014.01-5.31 5.308a2.668 2.668 0 0 1-4.084 3.378 2.666 2.666 0 0 1 2.907-4.361c.17.072.33.161.481.266Zm-4.178 17.025c.029-.352.128-.695.29-1.009v.001a2.667 2.667 0 0 1 4.943 1.912l13.332 6.666a2.667 2.667 0 0 1 4.495 2.807 2.667 2.667 0 0 1-4.958-1.92l-13.3-6.651a2.67 2.67 0 0 1-4.165.152 2.667 2.667 0 0 1-.637-1.958Z"
        clipRule="evenodd"
      />
      <path
        fill={primary}
        d="m44.008 41.162 1.845-1.845-.283-.283h-.848l-1.432 1.432c.096.137.204.265.324.383.118.114.245.215.38.304l.014.01Z"
      />
      <path
        fill="#fff"
        d="M89.114 112.963c7.403 0 13.404-5.996 13.404-13.393s-6.001-13.393-13.404-13.393S75.71 92.173 75.71 99.57s6.001 13.393 13.404 13.393Z"
      />
      <path
        fill="url(#a)"
        fillRule="evenodd"
        d="M89.114 112.964c7.403 0 13.404-5.997 13.404-13.394s-6.001-13.393-13.404-13.393S75.71 92.173 75.71 99.57s6.001 13.394 13.404 13.394Zm1.675-18.416a1.675 1.675 0 0 0-3.35 0v3.348h-3.351a1.675 1.675 0 1 0 0 3.348h3.35v3.349a1.674 1.674 0 0 0 1.676 1.676 1.677 1.677 0 0 0 1.676-1.676v-3.349h3.35a1.674 1.674 0 1 0 0-3.348h-3.35l-.001-3.348Z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        d="M73.436 22.08c0 2.8 1.965 5.24 4.737 5.647 1.976.29 3.973.513 5.99.664a2.001 2.001 0 0 1 1.514.876l4.822 7.233 4.82-7.233a1.993 1.993 0 0 1 1.515-.877c2.004-.15 4.002-.37 5.99-.663 2.772-.407 4.737-2.845 4.737-5.649V11.547c0-2.804-1.965-5.242-4.737-5.65A84.865 84.865 0 0 0 90.499 5c-4.186 0-8.302.306-12.326.898-2.772.408-4.737 2.847-4.737 5.649V22.08Z"
      />
      <path
        fill={primary}
        fillOpacity=".25"
        d="M73.436 22.08c0 2.8 1.965 5.24 4.737 5.647 1.976.29 3.973.513 5.99.664a2.001 2.001 0 0 1 1.514.876l4.822 7.233 4.82-7.233a1.993 1.993 0 0 1 1.515-.877c2.004-.15 4.002-.37 5.99-.663 2.772-.407 4.737-2.845 4.737-5.649V11.547c0-2.804-1.965-5.242-4.737-5.65A84.865 84.865 0 0 0 90.499 5c-4.186 0-8.302.306-12.326.898-2.772.408-4.737 2.847-4.737 5.649V22.08Z"
      />
      <path
        stroke={primary}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M82.625 14.188h15.75m-15.75 5.25H90.5M73.436 22.08c0 2.8 1.965 5.24 4.737 5.647 1.976.29 3.973.513 5.99.664a2.001 2.001 0 0 1 1.514.876l4.822 7.233 4.82-7.233a1.993 1.993 0 0 1 1.515-.877c2.004-.15 4.002-.37 5.99-.663 2.772-.407 4.737-2.845 4.737-5.649V11.547c0-2.804-1.965-5.242-4.737-5.65A84.865 84.865 0 0 0 90.499 5c-4.186 0-8.302.306-12.326.898-2.772.408-4.737 2.847-4.737 5.649V22.08Z"
      />
      <path
        fill="#fff"
        stroke={primary}
        d="M137.5 69.5h-13A1.5 1.5 0 0 0 123 71v13a1.5 1.5 0 0 0 1.5 1.5h13A1.5 1.5 0 0 0 139 84V71a1.5 1.5 0 0 0-1.5-1.5Z"
      />
      <path
        fill={primary}
        d="M126.417 79.97v-.94c0-.458.287-.858.695-.97l.222-.06.575-.157c.173-.047.342.096.342.291v2.732c0 .195-.169.338-.342.29l-.797-.217c-.408-.111-.695-.51-.695-.969Zm9.166 0v-.94c0-.458-.286-.858-.694-.97l-.222-.06-.575-.157c-.173-.047-.341.096-.341.291v2.732c0 .195.168.338.341.29l.797-.217c.408-.111.694-.51.694-.969Z"
      />
      <path
        stroke={primary}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth=".5"
        d="M127.334 78v-.25c0-2.485 1.642-4.5 3.667-4.5s3.666 2.015 3.666 4.5V78m-7.333 0-.222.06c-.408.112-.695.512-.695.97v.94c0 .459.287.858.695.969l.797.217c.173.048.342-.095.342-.29v-2.732c0-.195-.169-.338-.342-.291l-.575.157Zm7.333 0 .222.06c.408.112.694.512.694.97v.94c0 .459-.286.858-.694.969l-.797.217c-.173.048-.341-.095-.341-.29v-2.732c0-.195.168-.338.341-.291l.575.157Z"
      />
      <defs>
        <linearGradient
          id="a"
          x1="89.114"
          x2="89.114"
          y1="86.177"
          y2="112.964"
          gradientUnits="userSpaceOnUse">
          <stop stopColor={chroma(primary).brighten(0.5 - 0)} />
          <stop offset="1" stopColor={primary} />
        </linearGradient>
      </defs>
    </Graphic>
  );
};
export default LiveChat;
